import {
    FETCH_SINGLE_DAILY_RELEASED_TESTS_REQUEST,
    FETCH_SINGLE_DAILY_RELEASED_TESTS_FAILURE,
    FETCH_SINGLE_DAILY_RELEASED_TESTS_SUCCESS
} from "constants/SingleReleasedDailyReleasedTests"

const initState = {
     list : [],
     loading : false,
     errorMessage : ""
}

const SingleReleasedDailyReleasedTests = (state = initState, action)=>{
    switch(action.type){
        case FETCH_SINGLE_DAILY_RELEASED_TESTS_REQUEST : 
        return{
            loading : true
        }
        case FETCH_SINGLE_DAILY_RELEASED_TESTS_SUCCESS : 
        return{
            loading : false,
            list : action.payload
        }
        case FETCH_SINGLE_DAILY_RELEASED_TESTS_FAILURE : 
        return {
            loading : false,
            errorMessage : action.errorMessage
        }
        default : 
        return state
    }
}

export default SingleReleasedDailyReleasedTests;